import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwitchAccessShortcutIcon(props: IconProps) {
    return <Icon {...props} iconKey={"switch_access_shortcut"}/>
}
